import { defineStore } from 'pinia';

export const useScreenSizeStore = defineStore({
  id: 'screenSizeStore',
  state: () => ({
    screenSize: null,
    isDesktop: null
  }),
});
